import { render, staticRenderFns } from "./Recommended.vue?vue&type=template&id=6a789a80&"
import script from "./Recommended.vue?vue&type=script&lang=js&"
export * from "./Recommended.vue?vue&type=script&lang=js&"
import style0 from "./Recommended.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports